import { SelectProps } from 'antd';
import { useEffect, useState } from 'react';

import { SelectInput, CheckboxInput } from '@thinknet-gmbh/platform-common-ui';
import { DatevClientsSelectStyledInput } from '../../../../../../../../health-insurance.styles';

interface IOption {
  label: string;
  value: string;
  disabled?: boolean;
}

const DatevClientsSelect = ({
  optionData,
  onSelectClientNumber,
  ...props
}: SelectProps<any> & {
  optionData: { value: string; disabled?: boolean; label: string }[];
  onSelectClientNumber: () => void;
}) => {
  const [optionValue, setOptionValue] = useState<IOption>({} as IOption);

  useEffect(() => {
    if (props.value) {
      const values = props.value.map((value: any) => ({ [value]: true }));

      setOptionValue(Object.assign({}, ...values));
    }
  }, [props.value]);

  return (
    <DatevClientsSelectStyledInput
      {...props}
      mode="multiple"
      showArrow={true}
      tagRender={props => {
        // @ts-ignore
        const labelEl = props.label![1];
        const label = labelEl.split('-');
        return label[0];
      }}
      onSelect={value => {
        setOptionValue(oldValue => ({ ...oldValue, [value]: true }));
        onSelectClientNumber()
      }}
      onDeselect={value => {
        setOptionValue(oldValue => ({ ...oldValue, [value]: false }));
        onSelectClientNumber()
      }}
    >
      {optionData.map((item: IOption, index) => {
        const { value, label, disabled } = item;
        // @ts-ignore
        const checked = optionValue[value];
        return (
          <SelectInput.Option value={value} key={index} disabled={disabled}>
            <CheckboxInput disabled={disabled} checked={checked} />
            {label}
          </SelectInput.Option>
        );
      })}
    </DatevClientsSelectStyledInput>
  );
};

export default DatevClientsSelect;
